import {
  Select,
  SelectItem,
  SelectPopup,
  SelectTrigger,
  SelectValue,
  Text,
} from "@salestrak/ui";

type LogicSelectProps = {
  value: "AND" | "OR";
  onChange: (logic: "AND" | "OR") => void;
};

export function LogicSelect({ value, onChange }: LogicSelectProps) {
  return (
    // Base UI's Select is value-based (no `{value,label}` option object) and
    // its trigger already fills its container.
    <Select
      value={value}
      onValueChange={(next: "AND" | "OR" | null) => {
        if (next) onChange(next);
      }}
    >
      <SelectTrigger size="sm">
        <SelectValue placeholder="Logic" />
      </SelectTrigger>
      <SelectPopup>
        <SelectItem value="AND">
          <Text>AND</Text>
        </SelectItem>
        <SelectItem value="OR">
          <Text>OR</Text>
        </SelectItem>
      </SelectPopup>
    </Select>
  );
}
